export enum FrequencyOfPaymentEnum {
  Daily,
  Weekly,
  Fortnightly,
  Monthly
}

export namespace FrequencyOfPaymentEnum {
  export function values() {
    return Object.keys(FrequencyOfPaymentEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
